import React from "react";
import { Link, useParams } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { LEGAL_DOCS } from "@/data/ambassadorProgramme";
import { LegalLinks } from "@/pages/AmbassadorsPage";

export default function AmbassadorLegalPage() {
  const { slug } = useParams();
  const doc = LEGAL_DOCS.find((d) => d.slug === slug) || LEGAL_DOCS[0];
  useSeo({ title: `${doc.title} - CSI Ambassador Programme`, description: `${doc.title} of the CSI Ambassador Programme: ${doc.sections[0].p[0]}`, path: `/ambassadors/legal/${doc.slug}` });
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid={`legal-doc-${doc.slug}`}>
      <Link to="/ambassadors" className="text-xs text-[var(--gold-deep)] hover:underline">← Ambassador Programme</Link>
      <div className="eyebrow mt-4 mb-1">CSI Ambassador Programme · Version 1.0</div>
      <h1 className="font-display text-4xl sm:text-5xl">{doc.title}</h1>
      <div className="mt-8 space-y-6">
        {doc.sections.map((s) => (
          <section key={s.h}>
            <h2 className="font-display text-xl mb-2">{s.h}</h2>
            {s.p.map((p, i) => <p key={i} className="text-sm text-zinc-700 leading-relaxed mb-2">{p}</p>)}
          </section>
        ))}
      </div>
      <div className="mt-10 pt-6 border-t border-[var(--border-warm)]"><LegalLinks/></div>
    </div>
  );
}
